export function farloUiMastheadCarousel(element) {


    let flktyCarousel = new Flickity(element, {
        cellAlign: 'center',
        pageDots: false,
        prevNextButtons: true,
        wrapAround: true,
        groupCells: false,
        autoplay:true,
        draggable:false,
        pauseAutoPlayOnHover: false,
        fullscreen: true,
    });

        // Handle window resizing
        const onResize = () => {
            flktyCarousel.destroy(); 
            flktyCarousel = new Flickity(element, {
                cellAlign: 'center',
                pageDots: false,
                prevNextButtons: false,
                wrapAround: true,
                groupCells: false,
                autoplay:true,
                draggable:false,
                pauseAutoPlayOnHover: false,
                fullscreen: true,
                });
        };

    window.addEventListener('resize', onResize);
}
